export default "__VITE_ASSET__BYTDPC4G__"